import { LoanIncreaseState } from './reducer';

export const getLoanIncreases = (state: {
  loanIncreases?: LoanIncreaseState
}) => state.loanIncreases?.loanIncreases ?? [];

export const getLoanIncreaseLoader = (state: { loanIncreases: LoanIncreaseState }) => 
  state.loanIncreases.isLoading 
